import type { FunctionComponent, MouseEventHandler, Ref } from 'react';

import { intl } from '@trello/i18n';
import { Button } from '@trello/nachos/button';
import { AddIcon } from '@trello/nachos/icons/add';
import type { TeamTestClasses } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './BoardListItemTagAdd.less';

export interface BoardListItemTagAddProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  canAddTag: boolean;
  triggerRef: Ref<HTMLButtonElement>;
}

export const BoardListItemTagAdd: FunctionComponent<
  BoardListItemTagAddProps
> = ({ onClick, canAddTag, triggerRef }) => {
  if (!canAddTag) {
    return null;
  }

  return (
    <Button
      className={styles.boardTagAdd}
      data-testid={getTestId<TeamTestClasses>('add-collection-button')}
      iconBefore={
        <AddIcon
          size="xsmall"
          label={intl.formatMessage({
            id: 'templates.board_list.add-new-collection',
            defaultMessage: 'Add a new collection',
            description:
              'The button for a user to add a Trello board to a collection',
          })}
        />
      }
      onClick={onClick}
      ref={triggerRef}
    ></Button>
  );
};
